import React from "react";
import { Flex, Skeleton } from "@chakra-ui/react";
import { HorizontalTabsPlacement, TabItem } from "./HorizontalTabs";

interface HorizontalTabsSkeletonProps {
  tabs: TabItem[];
  centerTabs?: boolean;
  showContent?: boolean;
  fullWidthContent?: boolean;
  isInModal?: boolean;
  isEmbeddedContent?: boolean;
  innerModalHeight?: string;
  outerModalHeight?: string;
  placementToUse?: HorizontalTabsPlacement;
}

export const HorizontalTabsSkeleton: React.FC<HorizontalTabsSkeletonProps> = ({
  tabs,
  centerTabs = false,
  showContent = false,
  fullWidthContent = false,
  isInModal = false,
  isEmbeddedContent = false,
  innerModalHeight = "calc(100vh - 16rem)",
  outerModalHeight = "calc(100vh - 9rem)",
  placementToUse: placement = HorizontalTabsPlacement.EVERYWHERE,
}) => {
  const isTalentCommunity =
    placement === HorizontalTabsPlacement.TALENT_COMMUNITY;

  const listBgColor = isTalentCommunity
    ? "themeColor.bg.heading"
    : "themeColor.bg.muted";
  const verticalPadding = isTalentCommunity ? 1 : 3;
  const borderRadius = isTalentCommunity ? "2xl" : "lg";

  return (
    <Flex direction="column" gap={2}>
      <Flex justify={centerTabs ? "center" : "flex-start"} width="100%">
        <Flex
          bg={listBgColor}
          p={1}
          borderRadius="lg"
          gap={1.5}
          border="none"
          boxShadow="none"
          display="flex"
          width="fit-content"
        >
          {tabs.map((tab) => (
            <Skeleton
              key={tab.id}
              borderRadius={borderRadius}
              px={3.5}
              py={verticalPadding}
              minW="fit-content"
              h={8}
              w={24}
              bg="themeColor.bg.subHeading"
            />
          ))}
        </Flex>
      </Flex>
      {showContent && (
        <Flex
          mt={2}
          width={fullWidthContent ? "100%" : "auto"}
          border={isEmbeddedContent ? "none" : "1px solid"}
          borderColor={
            isEmbeddedContent ? "transparent" : "themeColor.border.muted"
          }
          borderRadius="lg"
          h={isInModal ? innerModalHeight : outerModalHeight}
          overflow="auto"
          p={isEmbeddedContent ? 2 : 4}
        >
          <Flex direction="column" gap={4} width="100%">
            <Skeleton
              height="24px"
              width="200px"
              bg="themeColor.bg.subHeading"
            />
            <Skeleton
              height="16px"
              width="100%"
              bg="themeColor.bg.subHeading"
            />
            <Skeleton height="16px" width="90%" bg="themeColor.bg.subHeading" />
            <Skeleton height="16px" width="85%" bg="themeColor.bg.subHeading" />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
